/**
 * BeneficiaryInfoBanner.js
 *
 * Shared component for displaying beneficiary payment information
 * Shows amount sent to PayPal account
 */

import React from 'react';
// import { SERVER_URL } from '../config';
// import { BENEFICIARY_INFO_MESSAGE } from '../utils/constants';

function BeneficiaryInfoBanner({ amount, userId }) {
  // Stripe payout schedule - kept for reference
  // const handleViewPayoutSchedule = async () => {
  //   try {
  //     const response = await fetch(`${SERVER_URL}/users/${userId}/stripe-dashboard-link`, {
  //       method: 'POST',
  //     });
  //     if (response.ok) {
  //       const data = await response.json();
  //       window.open(data.url, '_blank');
  //     } else {
  //       alert('Failed to open payment settings. Please try again.');
  //     }
  //   } catch (err) {
  //     console.error('Error opening payment settings:', err);
  //     alert('Failed to open payment settings. Please try again.');
  //   }
  // };

  return (
    <div className="mb-3 bg-gray-50 border border-gray-200 rounded-lg p-2.5 sm:p-3">
      <div className="flex items-start gap-2">
        <div className="text-sm flex-shrink-0">💰</div>
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline justify-between gap-2 mb-1">
            <h4 className="font-semibold text-gray-700 text-xs sm:text-sm">
              ${(Math.round(amount * 100) / 100).toFixed(2)} sent to PayPal
            </h4>
            <span className="text-[9px] text-gray-400 italic whitespace-nowrap">
              Only you see this
            </span>
          </div>
          <p className="text-[10px] sm:text-xs text-gray-600 leading-relaxed">
            Funds will be available in your PayPal account within a few days. No action needed.
          </p>
          {/* Stripe payout schedule link - kept for reference
          <button
            onClick={handleViewPayoutSchedule}
            className="text-[10px] text-indigo-600 hover:text-indigo-800 font-medium transition-colors"
          >
            View payout schedule →
          </button>
          */}
        </div>
      </div>
    </div>
  );
}

export default BeneficiaryInfoBanner;
